import React from 'react';
import styles from './styles.module.css';

interface DropdownItemProps {
  children: React.ReactNode;
}

export const DropdownItem = ({ children }: DropdownItemProps) => {
  return <div className={styles.item}>{children}</div>;
};
